/**
 * Matcher for platform type
 *
 * Ported from [condition.testPlatform@06b84fe4c24d26712823dff967db3632093d64fd](https://github.com/optimizely/optimizely/blob/06b84fe4c24d26712823dff967db3632093d64fd/src/www/js/client/condition.js#L662)
 *
 * @module
 */

exports.fieldsNeeded = ['platform'];

exports.match = function(value, cond) {
  var platform = value.platform;

  var targetedPlatform = cond.value,
      // Split platform name from version.
      targetedPlatformParts = targetedPlatform.split('_'),
      targetedPlatformName = targetedPlatformParts[0];

  return targetedPlatformName === platform.name;
};
